/*
 * SW step22: product gallery videos never flash when their slide becomes active.
 *
 * The theme (theme.js VideoMedia) sets [loaded] on <video-media> the moment play() is requested, which fades out the
 * sharp preview <img> and shows the bare <video>: preload="none", a 400px poster attribute, and on iOS Safari a black
 * box until the first frame is decoded ('playing' fires before that frame is painted). That is the flash.
 *
 * Here (with the matching rules in sw-styles.css) the preview <img> stays visible until the video has actually
 * presented a frame (requestVideoFrameCallback, or timeupdate with currentTime > 0 as a fallback), then
 * [sw-video-ready] fades it out. On pause, end or reload the image comes back. If autoplay is refused (iOS Low Power
 * Mode) the image simply stays.
 * Also: the slide being swiped to starts loading as soon as the carousel commits to it, slides swiped away are always
 * paused, and an active video gets up to 3 more chances (2.5 s apart) if play() did not take or the load stalled.
 *
 * Event delegation on document (capture phase, media and carousel events do not bubble), so galleries rendered later
 * (quick buy) are covered once this file has run. Loaded from snippets/product-gallery.liquid; runs once per page.
 */
(function () {
  if (window.__swGalleryVideo) return;
  window.__swGalleryVideo = true;

  var VIDEO_SELECTOR = '.product-gallery video-media[type="video"] > video';

  function galleryVideo(target) {
    return target && target.tagName === 'VIDEO' && target.matches(VIDEO_SELECTOR) ? target : null;
  }
  function cellVideo(cell) {
    return cell && cell.getAttribute('data-media-type') === 'video' ? cell.querySelector('video-media[type="video"] > video') : null;
  }
  function markReady(video) {
    if (!video.paused) video.parentElement.setAttribute('sw-video-ready', '');
  }
  function unmarkReady(video) {
    video.parentElement.removeAttribute('sw-video-ready');
  }

  // Reveal only once a frame is really on screen.
  document.addEventListener('playing', function (event) {
    var video = galleryVideo(event.target);
    if (!video) return;
    if (typeof video.requestVideoFrameCallback === 'function') {
      video.requestVideoFrameCallback(function () { markReady(video); });
    }
  }, true);
  document.addEventListener('timeupdate', function (event) {
    var video = galleryVideo(event.target);
    if (video && video.currentTime > 0) markReady(video);
  }, true);
  // Back to the preview image when paused (swiped away, or ended without loop) or reloaded.
  ['pause', 'emptied'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var video = galleryVideo(event.target);
      if (video) unmarkReady(video);
    }, true);
  });

  function isSelected(carousel, cell) {
    return carousel && carousel.selectedCell === cell;
  }

  // The carousel committed to a new slide (mid-swipe): pause every other gallery video, start loading the target.
  document.addEventListener('carousel:change', function (event) {
    var carousel = event.target;
    if (!carousel.closest || !carousel.closest('.product-gallery')) return;
    var target = event.detail && event.detail.cell;
    carousel.querySelectorAll('video-media[type="video"] > video').forEach(function (video) {
      if (target && target.contains(video)) return;
      if (video._swWatch) { clearTimeout(video._swWatch); video._swWatch = null; }
      if (!video.paused) { try { video.pause(); } catch (e) {} }
    });
    var video = cellVideo(target);
    if (!video) return;
    if (video.preload !== 'auto') video.preload = 'auto';
    // An element that never loaded (preload none) or suspended after metadata needs load() to start fetching now.
    if (video.paused && video.readyState < 2 && video.networkState !== 2) video.load();
  }, true);

  // The slide settled: the theme calls play() once (autoplay-media). Give it more chances if that did not take.
  document.addEventListener('carousel:settle', function (event) {
    var carousel = event.target;
    var gallery = carousel.closest && carousel.closest('.product-gallery');
    if (!gallery || !gallery.hasAttribute('autoplay-media')) return;
    var cell = event.detail && event.detail.cell;
    var video = cellVideo(cell);
    if (!video) return;
    var tries = 0;
    function check() {
      video._swWatch = null;
      if (!isSelected(carousel, cell) || document.hidden) return;
      var playing = !video.paused && video.parentElement.hasAttribute('sw-video-ready');
      if (playing) return;
      if (++tries > 3) return; // e.g. Low Power Mode refusing autoplay: the preview image stays
      if (video.readyState < 2 && video.networkState !== 2) video.load(); // nothing buffered and not loading
      video.muted = true;
      video.play().catch(function () {});
      video._swWatch = setTimeout(check, 2500);
    }
    if (video._swWatch) clearTimeout(video._swWatch);
    video._swWatch = setTimeout(check, 2500);
  }, true);
})();
